import React, {useState} from "react";
import {BUTTON_TYPES, FIELDS_TYPES, IFormFields, INPUT_PLACEHOLDERS, MODAL_STEPS} from "../../types";
import {Button, InputPhone, Select} from "../common";
import Input from "../common/Input";
import {phoneRegex} from "../../utils/regex";
import clsx from "clsx";

const ReqSecondStep = (
  { data, onClose, handleChangeStep, onSubmit, isProduct = false }:
  {
    data: IFormFields | undefined;
    onClose: () => void;
    isProduct?: boolean
    handleChangeStep: (step: string, data: any) => void;
    onSubmit: (data: any) => void
  }
) => {
  const [errorText, setErrorText] = useState<string | boolean>(false);
  const [errorRequiredField, setErrorRequiredField] = useState<{ [key: string]: string} | null>(null);
  const [errorType, setErrorType] = useState<string>('');
  const [requestData, setRequestData] = useState<Array<{ name: string; value: string }> | []>([]);
  const [selectedData, setSelectedData] = useState<{ [key: string]: {
      id?: string; label?: string
    } } | null>(null);

  const handleInputData = (value: any, name: string, type?: string) => {
    if (type === FIELDS_TYPES.SELECT) {
      const obj = {
        ...selectedData,
        [name]: {
          id: value,
          label: value,
        }
      }
      setSelectedData(obj);
    }

    const obj = {
      name,
      value
    };

    const data = [...requestData];

    if (!data.length) {
      data.push(obj);
      setRequestData(data);
    } else if (data.length) {
      const hasData = data?.find(i => i.name === name);

      if (hasData) {
        hasData.value = value;
        setRequestData(data)
      } else {
        data.push(obj);
        setRequestData(data);
      }
    }
  }

  const handleSubmit = () => {
    if (!checkField()) {
      return;
    }

    const hasMobileNumber = requestData.find(i => i.name === 'phone_number');
    const hasInn = requestData.find(i => i.name.includes('inn'));

    if (hasInn && hasInn.value.length !== 10 && hasInn.value.length !== 12) {
      setErrorType(hasInn?.name);
      setErrorText('Номер ИНН должен быть 10 или 12 символов!');
      return;
    }

    if (hasMobileNumber && (hasMobileNumber.value.length !== 11 || !phoneRegex.test(hasMobileNumber.value))) {
      setErrorType(hasMobileNumber?.name);
      setErrorText(`Номер должен быть в формате ${INPUT_PLACEHOLDERS.PHONE} и не более 11 символов`);
      return;
    }

    setErrorType('');
    setErrorText(false);
    onSubmit(requestData);
  }

  const checkField = () => {
    let requiredFields: { [key: string]: string} | null = null;

    data?.fields?.forEach(i => {
      if (i.required) {
        requiredFields = {
          ...requiredFields,
          [i?.name]: 'Поле должно быть заполнено'
        }
      }
    });

    if (!requestData?.length) {
      setErrorRequiredField(requiredFields);
      return;
    }

    requestData?.forEach((item) => {
      if (requiredFields && Object.keys(requiredFields).some(i => i === item.name)) {
        requiredFields[item.name  as keyof typeof requiredFields] = '';
      }
    })

    setErrorRequiredField(requiredFields);

    return requiredFields && Object.values(requiredFields)?.every(i => i === '');
  }


  return (
    <div className="max-h-[93%] overflow-y-scroll">
      {!isProduct && <h2 className="text-[18px] leading-[24px] text-black font-bold mb-5">Шаг 2</h2>}
      <p className="text-[14px] leading-[24px] text-black font-medium mb-1">Банк: {data?.bank}</p>
      <p className={
        clsx(
          "text-[14px] leading-[24px] text-black font-medium",
          data?.description ? "mb-1" : "mb-5"
        )
      }>
        Продукт: {isProduct ? data?.name : data?.product_type}
      </p>
      {data?.description && <p className="text-[14px] leading-[24px] text-black font-medium mb-5">
        Примечание: {data?.description}
      </p>}

      {
        data?.fields?.map((i, index) => (
          <div key={index} className="w-full mb-3">
            <p className="text-[14px] leading-[24px] text-black font-medium mb-1">{i.label}</p>
            {
              i.type === FIELDS_TYPES.SELECT
                ? <Select
                  onChange={(e) => handleInputData(e, i.name, i.type)}
                  error={
                    errorType === i.name && errorText || (i.required && errorRequiredField?.[i?.name])
                  }
                  activeData={selectedData?.[i.name] || {}}
                  value={i?.options?.map(i => ({
                    id: i,
                    label: i,
                  }))}
                />
                : i.type === FIELDS_TYPES.PHONE
                  ? <InputPhone
                      error={
                        errorType === i.name && errorText || (i.required && errorRequiredField?.[i?.name])
                      }
                      onChange={(e: any) => handleInputData(e.target.value, i.name, i.type)}
                      className="w-full mb-1"
                    />
                  : <Input
                      id={i.type}
                      name={i.type}
                      error={
                        (errorType === i.name && errorText) || (i.required && errorRequiredField?.[i?.name])
                      }
                      className="w-full mb-1"
                      onChange={(e) => handleInputData(e.target.value, i.name, i.type)}
                      type={i.type}
                    />
            }
          </div>
        ))
      }

      <div className="mt-6 flex items-center gap-2">
        <Button
          title={'Отправить заявку'}
          type={BUTTON_TYPES.SECONDARY}
          onClick={handleSubmit}
        />
        {
          !isProduct && (
            <Button
              title={'Назад'}
              type={BUTTON_TYPES.PRIMARY}
              onClick={() => handleChangeStep(MODAL_STEPS.CHOOSE_BANK_AND_PRODUCT, null)}
            />
          )
        }
        <Button
          title={'Отмена'}
          type={BUTTON_TYPES.GRAY}
          onClick={onClose}
        />
      </div>
    </div>
  )
};

export default ReqSecondStep;
